import { render, staticRenderFns } from "./TemplateDesignTestView.vue?vue&type=template&id=a733fefc"
import script from "./TemplateDesignTestView.vue?vue&type=script&lang=ts"
export * from "./TemplateDesignTestView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports